<template>
  <b-row align-h="center" class="row mt-md-10" v-if="showUsp">
    <b-col
      class="col-12 col-md-3 text-center mb-4 mb-md-0"
      v-for="(item, index) in itemsToShow"
      :key="index"
    >
      <img
        class="d-inline-block mb-3"
        style="height: 50px"
        :src="require(`@/assets/icons/${item.image}`)"
      />
      <p class="mb-5 mb-md-0" v-dynamic-content="{ rawText: content[item.text] }"></p>
    </b-col>
  </b-row>
</template>

<script>
const contentKeys = {
  usp_local_installers: 'local-installers.svg',
  usp_zonnekeur_keurmerk: 'logos/logo-keurmerken-zonnekeur.svg',
  usp_total_installations: 'number-of-houses.svg',
  usp_engie_group: 'logos/engie-blue.svg',
}
export default {
  computed: {
    showUsp() {
      return Object.keys(this.content).some((key) => Object.keys(contentKeys).includes(key))
    },
    itemsToShow() {
      return Object.keys(contentKeys)
        .filter((key) => Object.keys(this.content).includes(key))
        .map((key) => ({
          text: key,
          image: contentKeys[key],
        }))
    },
  },
}
</script>
